import { AXIOSMETHOD } from "constants/enum_axios_methods";
import client from "api";

interface ISendData<T = any> {
  method?: AXIOSMETHOD;
  data?: object;
  params?: object;
  headers?: any;
  responseType?: any;
  url?: string;
}

class ApiBuilder {
  send_data: ISendData = {
    method: undefined,
    data: undefined,
    params: undefined,
    headers: undefined,
    responseType: undefined,
    url: "",
  };
  onSuccess: any;
  onError: any;

  setBody(body: any) {
    if (this.send_data.method !== AXIOSMETHOD.JSON) {
      let data: any = typeof window !== "undefined" ? new FormData() : {};

      Object.keys(body).forEach((element, i) => {
        data.append(element, Object.values(body)[i]);
      });
      this.send_data.data = data;
    } else {
      this.send_data.method =
        this.send_data.method === AXIOSMETHOD.JSON ? AXIOSMETHOD.POST : this.send_data.method;
      this.send_data.data = body;
    }

    return this;
  }

  setParams(params: any) {
    this.send_data.params = params;
    return this;
  }

  setHeader(headers: any) {
    this.send_data.headers = headers;
    return this;
  }

  setResponseType(value: any) {
    this.send_data.responseType = value;
    return this;
  }

  setMethod(method: AXIOSMETHOD) {
    this.send_data.method = method;
    return this;
  }

  setUrl(url?: string) {
    this.send_data.url = url;
    return this;
  }

  setOnSuccess(onSuccess: any) {
    this.onSuccess = onSuccess;
    return this;
  }

  setOnError(onError: any) {
    this.onError = onError;
    return this;
  }

  async call(defaultLan?: string) {
    const lan = typeof window !== "undefined" ? localStorage.getItem("lang") : defaultLan;

    this.setHeader({ lan });
    if (this.onError) {
      try {
        const res = await client(this.send_data);
        this.send_data = {};
        return res?.data;
      } catch (error: any) {
        this.onError();
        this.send_data = {};
        return error.response;
      }
    } else {
      const res = await client(this.send_data);
      this.send_data = {};
      return res?.data;
    }
  }
}

let apiBuilder = new ApiBuilder();

export default apiBuilder;
